export function UserGroup(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="20"
        viewBox="0 0 24 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6963 5.09197C13.5895 2.6923 11.687 0.799999 9.34999 0.799999H8.64999C6.23707 0.799999 4.29999 2.81255 4.29999 5.27273L4.3045 5.37667C4.49462 7.5633 5.1216 9.19938 6.18137 10.1719C3.29626 11.0011 1.32413 13.206 0.372916 16.679C0.324477 16.8558 0.299988 17.0387 0.299988 17.2222C0.299988 18.2882 1.12137 19.2 2.20063 19.2H15.7992C15.9991 19.2 16.1973 19.1673 16.3868 19.1033C17.3806 18.7679 17.902 17.6832 17.6268 16.6789C16.6756 13.206 14.7035 11.0011 11.8189 10.1719C12.8784 9.19938 13.5054 7.5633 13.6955 5.37667L13.6997 5.24603L13.6963 5.09197ZM2.86192 16.7333C3.8785 13.6453 5.85855 12.2 8.99989 12.2L9.28228 12.204C12.2603 12.2891 14.1521 13.7389 15.1379 16.7333L15.158 16.8H2.83999L2.86192 16.7333ZM9.34999 3.2H8.64999C7.63199 3.2 6.78069 4.03639 6.7054 5.11679L6.70099 5.234L6.7208 5.43249C6.9659 7.75573 7.67511 8.7297 8.86572 8.79631L8.99999 8.8C10.2717 8.8 11.025 7.84177 11.2792 5.43249L11.298 5.228L11.2978 5.17214C11.2506 4.11452 10.4626 3.28262 9.49621 3.20579L9.34999 3.2Z"
          fill="currentColor"
        />
        <path
          d="M21.8926 18.2H19.8887C20.0465 17.5129 20.0397 16.7816 19.8451 16.0712C19.8202 15.9801 19.7946 15.8897 19.7684 15.8H21.109L21.0664 15.6808C20.5039 14.1683 19.6397 13.1714 18.4279 12.6463C17.5769 11.202 16.4834 10.0421 15.1729 9.19231C15.2814 8.92316 15.3799 8.64346 15.4684 8.35379C15.7179 8.63425 16.0233 8.77259 16.3846 8.79629L16.5 8.8C17.4765 8.8 18.0693 8.03451 18.2808 6.01072L18.299 5.816L18.2982 5.78121C18.2613 4.93674 17.6624 4.2812 16.9373 4.207L16.8 4.2H16.2C16.1025 4.2 16.0068 4.21052 15.9138 4.23064C15.7838 3.41242 15.5153 2.64455 15.1337 1.95316C15.472 1.85344 15.8296 1.8 16.2 1.8H16.8C18.9023 1.8 20.6019 3.52573 20.6968 5.70268L20.6997 5.83748L20.6957 5.96548C20.5278 7.93604 19.9625 9.41767 19.0003 10.2928C21.2745 11.1223 22.8473 12.9929 23.63 15.819C23.8931 16.7688 23.3949 17.7937 22.4492 18.1094C22.2697 18.1693 22.0819 18.2 21.8926 18.2Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
